import { Component, OnInit } from '@angular/core';
import { BusyService } from '../../shared/services/busy.service';
import { Router, ActivatedRoute } from '@angular/router';
import { OrganizationService } from '../../shared/services/organization.service';
import { StateService } from '../../shared/services/state.service';
import { Status } from '../../shared/models/Status';
import { StatusService } from '../../shared/services/status.service';
import { DatePipe } from '@angular/common';
import { UpdateOrganizationStatus } from '../../shared/models/UpdateOrganizationStatus';
import { AlertService } from '../../shared/services/alert.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { requiredDelayValidator } from '../../shared/validators/requiredDelayValidator';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-organization-status',
  templateUrl: './organization-status.component.html',
  styleUrls: ['./organization-status.component.scss']
})
export class OrganizationStatusComponent implements OnInit {
  form: FormGroup;
  statuses: Status[];
  busy = false;
  org: any = {};
  model: any = {
    statusToday: 0,
    statusTomorrow: 0
  };
  statusDays: Date[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private busyService: BusyService,
    private statusService: StatusService,
    private organizationService: OrganizationService,
    private alertService: AlertService
  ) {
    this.busyService.initHandler('orgStatusCmp', busy => {
      this.busy = busy;
    });

    this.statusDays.push(new Date());
    this.statusDays.push(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));

    this.model.delayToday = new Date(new Date().setMinutes(0));
    this.model.delay2Today = new Date(new Date().setMinutes(0));
    this.model.delayTomorrow = new Date(new Date().setMinutes(0));
    this.model.delay2Tomorrow = new Date(new Date().setMinutes(0));

    this.form = new FormGroup({
      statusToday: new FormControl('', []),
      statusTomorrow: new FormControl('', []),
      delayToday: new FormControl('', []),
      delay2Today: new FormControl('', []),
      delayTomorrow: new FormControl('', []),
      delay2Tomorrow: new FormControl('', [])
    });
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      if (p['orgId'] > 0) {
        this.busyService
          .follow('orgStatusCmp', this.organizationService.get(p['orgId']))
          .subscribe(organization => {
            this.org = organization;
            this.model.orgId = organization.orgId;
          });
        this.busyService
          .follow(
            'orgStatusCmp',
            this.organizationService.getStatus(p['orgId'])
          )
          .subscribe(statuses => {
            if (!statuses) {
              return;
            }
            if (statuses.filter(item => item.statusDay === 0).length > 0) {
              this.model.statusToday = statuses.filter(item => item.statusDay === 0)[0].statusId;
              this.model.delayToday = new Date('01/01/0001 ' + statuses.filter(item => item.statusDay === 0)[0].delay);
              this.model.delay2Today = new Date('01/01/0001 ' + statuses.filter(item => item.statusDay === 0)[0].delay2);
            }
            if (statuses.filter(item => item.statusDay === 1).length > 0) {
              this.model.statusTomorrow = statuses.filter(item => item.statusDay === 1)[0].statusId;
              this.model.delayTomorrow = new Date('01/01/0001 ' + statuses.filter(item => item.statusDay === 1)[0].delay);
              this.model.delay2Tomorrow = new Date('01/01/0001 ' + statuses.filter(item => item.statusDay === 1)[0].delay2);
            }
          });
      }
    });
    this.route.data.subscribe(data => {
      this.busyService
        .follow('orgStatusCmp', this.statusService.all())
        .subscribe(statuses => {
          this.statuses = statuses;
        });
    });
  }

  save() {
    const datePipe = new DatePipe('en-US');
    // pipe.transform()

    const statuses: UpdateOrganizationStatus[] = [];

    const todayStatusItem = new UpdateOrganizationStatus();
    todayStatusItem.statusId = this.model.statusToday;
    todayStatusItem.delay = this.shouldShowTimeByStatus(todayStatusItem.statusId) 
        ? this.model.delayToday.toTimeString().slice(0, 5)
        : null;
    todayStatusItem.delay2 = this.shouldShowDelay2(todayStatusItem.statusId) 
        ? this.model.delay2Today.toTimeString().slice(0, 5)
        : null;
    todayStatusItem.statusDay = 0;

    const tomorrowStatusItem = new UpdateOrganizationStatus();
    tomorrowStatusItem.statusId = this.model.statusTomorrow;
    tomorrowStatusItem.delay = this.shouldShowTimeByStatus(tomorrowStatusItem.statusId) 
        ? this.model.delayTomorrow.toTimeString().slice(0, 5)
        : null;
    tomorrowStatusItem.delay2 = this.shouldShowDelay2(tomorrowStatusItem.statusId) 
        ? this.model.delay2Tomorrow.toTimeString().slice(0, 5)
        : null;
    tomorrowStatusItem.statusDay = 1;

    statuses.push(todayStatusItem);
    statuses.push(tomorrowStatusItem);

    this.busyService
      .follow(
        'orgStatusCmp',
        this.organizationService.updateStatus(this.org.orgId, statuses)
      )
      .subscribe(result => {
        this.alertService.showSuccess('The status was updated successfully.');
      });
  }

  cancel() {
    this.router.navigateByUrl('list');
  }

  goModifyOrg(){
    this.router.navigateByUrl('/orgedit/' + this.model.orgId);
  }

  private buildTimepart(datetime: Date) {
    return datetime.toTimeString();
  }

  shouldShowTimeByStatus(statusId: number): boolean {
    return environment.statusesWithDelay.includes(statusId);
  }

  shouldShowDelay2(statusId: number): boolean {
    return environment.statusesWithDelay2.includes(statusId);
  }

  getFromTimeLabel(statusId: number): string {
    return this.shouldShowDelay2(statusId)?"From":"Time";
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/authorized/organization-status/organization-status.component.ts